export default [
  {
    name: 'registration-controls',
    path: '/registration-controls',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Controle de Inscrição',
      icon: 'dvr',
      label: 'Controle de Inscrição',
      roles: ['Admin']
    }
  },
  {
    name: 'registration-control-items',
    path: '/registration-controls/:controlId/items',
    component: () => import(/* webpackChunkName: "event" */ './Items.vue'),
    meta: {
      showNavbar: true,
      title: 'Itens do Controle',
      icon: 'dvr',
      label: 'Itens do Controle',
      roles: ['Admin']
    }
  }
]
